import { createIcon } from '@chakra-ui/react';
import * as React from 'react';

export const MentorIcon = createIcon({
  displayName: 'MentorIcon',
  viewBox: '0 0 48 48',
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="21" cy="13" r="7" />
      <path d="M7 39v-3c0-8 6-13 14-13 3 0 5.5.6 7.5 2" />
      <path d="m36 25 2.6 5.2 5.7.8-4.1 4 .9 5.7-5.1-2.7-5.1 2.7 1-5.7-4.2-4 5.8-.8z" />
    </g>
  ),
});

export const MenteeIcon = createIcon({
  displayName: 'MenteeIcon',
  viewBox: '0 0 48 48',
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="19" cy="13" r="7" />
      <path d="M5 39v-3c0-8 6-13 14-13 4 0 7.5 1.5 10 4" />
      <path d="m30 29 8-4 8 4-8 4z" />
      <path d="M33 31v5c3 3 7 3 10 0v-5" />
      <path d="M46 29v8" />
    </g>
  ),
});
